import { Component, ViewChild, Input, Output, EventEmitter, OnInit, ViewEncapsulation, ElementRef } from '@angular/core';
import { ResortDetailsPageEvents } from '../instrumentation/resort-custom-events';
import { UserActivityDataContainer, UserActivityLogger, UserActivityLoggerOptions } from '../instrumentation/user-activity-logger.service';
declare var jQuery: any;

@Component({
    selector: 'modal-dialog',
    templateUrl: './modal-dialog.component.html',
    styleUrls: ['./modal-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ModalDialogComponent implements OnInit {
    @ViewChild('modalDialog') modal: ElementRef;

    constructor() { }

    ngOnInit() {
    }

    show() {
        jQuery(this.modal.nativeElement).modal('show');
        UserActivityLogger.logEvent(ResortDetailsPageEvents.ViewFloorPlanClicked, {}, UserActivityLoggerOptions.AppInsightsOnly);
    }

    hide() {
        jQuery(this.modal.nativeElement).modal('hide');
    }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/shared/modal-dialog.component.ts